import {
    buildClueMapFromDisplayClue,
    normalizeWord,
} from "../../../prototype/mobile-word-wheel/lib/gridReveal";

/**
 * Short Facebook caption variants (not the full template).
 * One is picked at random per preview load / “Shuffle caption”.
 */
export const FACEBOOK_PROMO_VARIANTS = [
    {
        id: "daily-challenge",
        headline: "🌊 Daily Mini Puzzle Challenge! 🧩",
        body: [
            "Can you help us solve today’s open clue?",
            "Unscramble the wheel letters and drop your guess in the comments! 👇",
        ],
    },
    {
        id: "brain-teaser",
        headline: "🧠 Quick word brain teaser",
        body: [
            "Spin the wheel. Find the word. Beat the clue.",
            "What do you get? Tell us below! 👇",
        ],
    },
    {
        id: "guess-clue",
        headline: "💡 Guess the word!",
        body: [
            "Here’s a clue from today’s Word Wheel Quest puzzle.",
            "Unscramble the letters on the wheel — comment your answer! 👇",
        ],
    },
    {
        id: "play-free",
        headline: "🧩 Free word puzzle for a short break",
        body: [
            "Almost solved — can you finish the last words?",
            "Play Word Wheel Quest free on Google Play! 📲",
        ],
    },
    {
        id: "comment-answer",
        headline: "🔥 Streak-friendly puzzle drop",
        body: [
            "One clue left on the board — what’s the word?",
            "Comment your guess, then play the full puzzle! 👇",
        ],
    },
];

export const FACEBOOK_HASHTAGS =
    "#WordWheelQuest #PuzzleGame #WordPuzzle #BrainTeaser";

/** One-liners shown on top of the Instagram square image (random pick). */
export const INSTAGRAM_OVERLAY_HEADLINES = [
    "🌊 Daily Mini Puzzle Challenge! 🧩",
    "🧠 Can you crack today’s word?",
    "💡 Spin. Unscramble. Solve!",
    "🔥 One clue left — what’s the word?",
    "🧩 Free brain teaser for your break",
    "✨ Word Wheel Quest — play today’s drop",
    "🎯 Guess the word from the clue!",
    "📲 Almost solved… finish the board!",
    "🌟 Quick word puzzle — try it now",
    "💪 Streak day? Drop your answer below",
    "🔤 Letters on the wheel — make the word!",
    "🏆 Beat the clue before your coffee cools",
    "🌈 Mini puzzle, max fun",
    "🔍 Look at the grid… what’s missing?",
    "⚡ 60-second word challenge",
    "🎮 Word Wheel Quest — free on Google Play",
    "📝 Unscramble the wheel letters!",
    "🧩 Daily puzzle drop is live",
    "💭 Think you’ve got it? Comment your guess",
    "🚀 Spin the wheel and find the answer!",
];

export function pickRandomPromoVariant(rng = Math.random) {
    const list = FACEBOOK_PROMO_VARIANTS;
    const idx = Math.floor(rng() * list.length) % list.length;
    return list[idx];
}

export function pickRandomInstagramHeadline(rng = Math.random) {
    const list = INSTAGRAM_OVERLAY_HEADLINES;
    const idx = Math.floor(rng() * list.length) % list.length;
    return list[idx];
}

/** Best remaining (unfound) clue for caption personalization. */
export function pickOpenClueLine(puzzle, foundWords = []) {
    const words = String(puzzle?.wordsInUse || "")
        .split("\n")
        .map((w) => normalizeWord(w.trim()))
        .filter(Boolean);
    const found = new Set((foundWords || []).map(normalizeWord));
    const open = words.filter((w) => !found.has(w));
    const focus = open[0] || words[0];
    if (!focus) return null;
    const clueMap = buildClueMapFromDisplayClue(puzzle?.displayClue);
    const clue = clueMap.get(focus);
    if (!clue) return null;
    return `💡 “${clue}”`;
}

/** Caption text for Graph photo post (promo + hashtags + Play link). No puzzle clue. */
export function buildFacebookCaption(promo, playStoreUrl) {
    const lines = [];
    if (promo?.headline) lines.push(promo.headline);
    if (Array.isArray(promo?.body)) {
        promo.body.forEach((line) => {
            if (line) lines.push(line);
        });
    }
    lines.push("");
    lines.push(FACEBOOK_HASHTAGS);
    if (playStoreUrl) {
        lines.push("");
        lines.push("📥 Download and play free on Android:");
        lines.push(playStoreUrl);
    }
    return lines.join("\n");
}

/** Instagram caption: overlay headline + hashtags + Play link. */
export function buildInstagramCaption(headline, playStoreUrl) {
    const lines = [];
    if (headline) lines.push(headline);
    lines.push("");
    lines.push(FACEBOOK_HASHTAGS);
    if (playStoreUrl) {
        lines.push("");
        lines.push("📥 Download and play free on Android:");
        lines.push(playStoreUrl);
    }
    return lines.join("\n");
}
